import {
  Badge,
  Button,
  Col,
  Container,
  Dropdown,
  Placeholder,
  Table,
} from "react-bootstrap";
import { HeadPage } from "src/componentes";
import MDFeEventoCode from "./MDFe.Evento.Code";
import MDFeEventoModalPropriedades from "./Modal.Propriedades/MDFe.Evento.Modal.Propriedades";
import { getDescricaoTipoEventoMDFe, MDFeEventoOutput } from "./MDFe.Evento.Dto";
import MDFeEventoModalCadastro from "./Modal.Cadastro/MDFe.Evento.Modal.Cadastro";
import React from "react";
import { useNavigate } from "react-router-dom";

const MDFeEventoView = () => {
  const code = MDFeEventoCode();
  const navigate = useNavigate();

  return (
    <Container>
      <HeadPage headText="Eventos MDF-e">
        <Dropdown.Item
          as={Button}
          onClick={() => code.onShowModalCadastro(true)}
        >
          Incluir Evento...
        </Dropdown.Item>
        <Dropdown.Item
          as={Button}
          onClick={() => navigate("/fiscal/mdfe")}
        >
          Voltar para Lista
        </Dropdown.Item>
      </HeadPage>

      {!code.loading ? (
        <Col>
          {code.data && code.data.length > 0 ? (
            <Table responsive hover className="mt-2">
              <thead>
                <tr>
                  <th style={{ width: "25%" }}>Tipo Evento</th>
                  <th style={{ width: "35%" }}>Detalhes</th>
                  <th style={{ width: "25%" }}>Situação na Receita</th>
                  <th style={{ width: "15%" }} className="text-end">
                    Ações
                  </th>
                </tr>
              </thead>
              <tbody>
                {code.data.map((item: MDFeEventoOutput) => {
                  const statusNum = Number(item.codigoStatusEnvio);
                  const isNaoEnviado = statusNum === 1;
                  const isHomologado =
                    statusNum === 4 ||
                    Boolean(
                      item.numeroProtocolo &&
                        Number(item.codigoStatusResposta) === 135
                    );
                  const isRejeitado = statusNum === 3;
                  const isProcessando = statusNum === 2;

                  return (
                    <React.Fragment key={item.id}>
                      <tr
                        style={{ cursor: "pointer" }}
                        onClick={code.handleClickPropriedades(item)}
                        className="align-middle"
                      >
                        <td className="fw-semibold">
                          <div className="d-flex align-items-center gap-2">
                            <span>
                              {getDescricaoTipoEventoMDFe(
                                item.tipoEvento,
                                item.tipoEventoDescricao
                              )}
                            </span>
                          </div>
                          {item.dataHoraEvento && (
                            <div className="text-muted small fw-normal">
                              Data: {item.dataHoraEvento}
                            </div>
                          )}
                        </td>
                        <td>
                          {item.cancelamento?.justificativaCancelamento && (
                            <div>
                              <small className="text-muted d-block">
                                Justificativa:
                              </small>
                              <span>
                                {item.cancelamento.justificativaCancelamento}
                              </span>
                            </div>
                          )}
                          {item.encerramento && (
                            <div>
                              <small className="text-muted d-block">
                                Encerramento:
                              </small>
                              <span>
                                Data: {item.encerramento.dataEncerramento} | IBGE:{" "}
                                {item.encerramento.codigoMunicipio}
                              </span>
                            </div>
                          )}
                        </td>
                        <td>
                          {isNaoEnviado ? (
                            <Badge
                              bg="warning"
                              text="dark"
                              className="px-2 py-2 d-inline-flex align-items-center gap-1 shadow-sm"
                            >
                              <span>⏳</span>
                              <span className="fw-bold">
                                NÃO ENVIADO PARA A RECEITA
                              </span>
                            </Badge>
                          ) : isHomologado ? (
                            <Badge
                              bg="success"
                              className="px-2 py-2 d-inline-flex align-items-center gap-1 shadow-sm"
                            >
                              <span>✓</span>
                              <span className="fw-bold">
                                ENVIADO E HOMOLOGADO
                              </span>
                            </Badge>
                          ) : isRejeitado ? (
                            <Badge
                              bg="danger"
                              className="px-2 py-2 d-inline-flex align-items-center gap-1 shadow-sm"
                            >
                              <span>✕</span>
                              <span className="fw-bold">
                                REJEITADO PELA RECEITA
                              </span>
                            </Badge>
                          ) : isProcessando ? (
                            <Badge
                              bg="info"
                              className="px-2 py-2 d-inline-flex align-items-center gap-1 shadow-sm"
                            >
                              <span>🔄</span>
                              <span className="fw-bold">EM TRANSMISSÃO</span>
                            </Badge>
                          ) : (
                            <Badge
                              bg="secondary"
                              className="px-2 py-2 d-inline-flex align-items-center gap-1 shadow-sm"
                            >
                              <span>
                                {item.codigoStatusEnvioDescricao || statusNum}
                              </span>
                            </Badge>
                          )}
                        </td>
                        <td className="text-end">
                          {isNaoEnviado ? (
                            <Button
                              size="sm"
                              variant="warning"
                              className="fw-bold shadow-sm d-inline-flex align-items-center gap-1 text-dark"
                              onClick={(e) => {
                                e.stopPropagation();
                                code.onSendModalPropriedades(item);
                              }}
                              title="Transmitir este evento agora para a SEFAZ"
                            >
                              <span>🚀</span>
                              <span>Transmitir</span>
                            </Button>
                          ) : (
                            <Button
                              size="sm"
                              variant="outline-secondary"
                              onClick={code.handleClickPropriedades(item)}
                            >
                              Detalhes
                            </Button>
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={4} className="p-2 small text-muted">
                          {isNaoEnviado ? (
                            <div className="d-flex align-items-center gap-2 text-warning-emphasis">
                              <span>⚠️</span>
                              <span>
                                <strong>Atenção:</strong> Evento pendente de
                                envio para a Receita Estadual (SEFAZ). Clique no
                                botão <strong>Transmitir</strong> para homologar.
                              </span>
                            </div>
                          ) : (
                            <div>
                              {item.numeroProtocolo && (
                                <span className="me-2 fw-semibold text-success">
                                  Protocolo: {item.numeroProtocolo}
                                </span>
                              )}
                              <span>
                                {item.codigoStatusResposta
                                  ? `${item.codigoStatusResposta} - ${item.descricaoMotivoResposta}`
                                  : item.descricaoMotivoResposta ||
                                    "Sem retorno da SEFAZ"}
                              </span>
                            </div>
                          )}
                        </td>
                      </tr>
                    </React.Fragment>
                  );
                })}
              </tbody>
            </Table>
          ) : (
            <div className="py-4 text-center text-muted">
              Nenhum evento registrado para este MDF-e. Clique em "Incluir
              Evento..." no menu para cancelar ou encerrar o documento.
            </div>
          )}
        </Col>
      ) : (
        <Placeholder animation="glow">
          <Placeholder xs={12} size="lg" className="mb-2" />
          <Placeholder xs={12} size="lg" />
        </Placeholder>
      )}

      <MDFeEventoModalPropriedades
        show={code.modalShowPropriedades}
        evento={code.evento}
        onReturn={code.onReturnModalPropriedades}
        onSend={code.onSendModalPropriedades}
        onDelete={code.onDeleteModalPropriedades}
      />

      <MDFeEventoModalCadastro
        show={code.modalShowCadastro}
        mdfeId={code.mdfeId}
        tipoEventoInicial={code.tipoEventoInicial}
        onClose={code.onShowModalCadastro}
        onReload={code.onReloadModalPropriedades}
      />
    </Container>
  );
};

export default MDFeEventoView;
